import differenceInSeconds from 'date-fns/difference_in_seconds';

export function isOlderThanSevenDays(pastDate) {
  const sevenDaysInSeconds = 604800;
  const difference = pastDate
    ? differenceInSeconds(Date.now(), new Date(pastDate))
    : null;
  return difference ? difference > sevenDaysInSeconds : true;
}
